import { formatToCPFOrCNPJ } from 'brazilian-values';
import type { TFunction } from 'i18next';

import { onlyNumbers } from '../onlyNumbers.tsx';

export const PIX_KEY_TYPE_ENUM = {
  CPF: 'CPF',
  CNPJ: 'CNPJ',
  EMAIL: 'EMAIL',
  PHONE: 'PHONE',
  RANDOM: 'RANDOM',
};

export const formatPixKeyTypeI18n = (t: TFunction, key: string): string => {
  const keys = {
    CPF: t('PIX_KEY_TYPE_ENUM.CPF'),
    CNPJ: t('PIX_KEY_TYPE_ENUM.CNPJ'),
    EMAIL: t('PIX_KEY_TYPE_ENUM.EMAIL'),
    PHONE: t('PIX_KEY_TYPE_ENUM.PHONE'),
    RANDOM: t('PIX_KEY_TYPE_ENUM.RANDOM'),
  };

  return keys[key];
};

export const formatPixKey = (pixKey: string, pixKeyType: string) => {
  if (pixKeyType === PIX_KEY_TYPE_ENUM.PHONE) {
    const phoneOnlyNumbers = onlyNumbers(pixKey);

    return `+${phoneOnlyNumbers}`;
  }

  if (
    pixKeyType === PIX_KEY_TYPE_ENUM.CPF ||
    pixKeyType === PIX_KEY_TYPE_ENUM.CNPJ
  ) {
    return formatToCPFOrCNPJ(pixKey);
  }

  return pixKey;
};
